<template>
  <v-flex  :v-if="dataReady">
    <metsankayttaja-slider v-if="qid(currentQuestion).type === 'slider'"></metsankayttaja-slider>
    <metsankayttaja-image v-if="qid(currentQuestion).type === 'image'"></metsankayttaja-image>
    <v-layout class="text-cs-center" mt-3>
      <v-flex xs6>
        <v-btn block v-if="currentQuestion > 1" @click="previousQuestion">Edellinen kysymys</v-btn>
      </v-flex>
      <v-flex xs6>
        <v-btn block v-if="currentQuestion < questions.length" @click="nextQuestion" >Seuraava kysymys</v-btn>
        <v-btn block v-if="currentQuestion === questions.length" @click="showResults" >Tulokset</v-btn>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar">
      Valitse yksi kuvista!
      <v-btn
        color="#87be23"
        flat
        @click="snackbar = false"
      >
        Sulje
      </v-btn>
    </v-snackbar>
  </v-flex>
  
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MetsankayttajaSlider from '@/components/metsankayttaja/questions/Slider';
import MetsankayttajaImage from '@/components/metsankayttaja/questions/Image';

export default {
  name: 'Question',
  components: {
    MetsankayttajaSlider,
    MetsankayttajaImage
  },

  computed: {
    ...mapState('metsankayttaja', ['stage', 'answers','questions', 'currentAnswers', 'currentQuestion', 'dataReady', 'disableButtons']),
    ...mapGetters('metsankayttaja', ['qid'])
  },

  data() {
    return {
      snackbar: false
    }
  },

  beforeUpdate() {
  },

  methods: {
    showResults() {
      this.$store.dispatch('metsankayttaja/showResults', {router: this.$router});
    },

    previousQuestion(a) {
      a.srcElement.disabled = true;
      this.$store.dispatch('metsankayttaja/previousQuestion', {router: this.$router});
    },

    nextQuestion(a,b) {
      if(this.answers[this.currentQuestion] === undefined) {
        this.snackbar = true;
      } else {
        a.srcElement.disabled = true;
        this.$store.dispatch('metsankayttaja/nextQuestion', {router: this.$router});
      }
    }
  },

  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
